import React from 'react';

export interface ArtworkImageProps {
    src: string;
}

const ArtworkImage = React.memo(function ArtworkImage(props: ArtworkImageProps) {
    const {src} = props;

    return <img crossOrigin="anonymous" src={src} alt="artwork"/>;
});

export default React.memo(ArtworkImage);
